import FlatButtons from "../FlatButton/FlatButton"
import Typography from "../Typography/Typography"
import styles from "./styles.module.css"

interface modalProps {
    open: boolean;
    toggle: () => void
}

export const DeleteProductModal: React.FC<modalProps> = ({
    open,
    toggle,
}) => {

    if(!open){
        return null
    }
    return (
        <div className={styles.overLay}>

            <div className={styles.container}>

                <div className={styles.content}>

                    <div className={styles.titleContainer}>

                        <Typography
                            variant="heading6"
                        >
                            Delete Product
                        </Typography>

                    </div>

                    <div className={styles.questionContainer}>

                        <Typography>
                            Are you sure you want to delete <span className={styles.bold}>“Crew Neck Shirt”</span>from product list?
                        </Typography>

                    </div>

                    <div className={styles.warningContainer}>

                        <div className={styles.warningTitle}>

                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#AD2323"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                aria-hidden="true"
                            >
                                <path d="M10.29 3.86l-7.02 14.09c-.45.9.11 2 1 2h14.46c.88 0 1.44-1.1.99-2L12.99 3.86a1.1 1.1 0 0 0-2 0z" />
                                <line x1="12" y1="9" x2="12" y2="13" />
                                <line x1="12" y1="17" x2="12" y2="17" />
                            </svg>

                            <Typography
                                variant="heading6"
                                className={styles.warningMessage}
                            >
                                warning
                            </Typography>

                        </div>

                        <Typography
                            className={styles.warningMessage}
                        >
                            By deleting this product, you will be removing it totally from available product in the store
                        </Typography>

                    </div>

                    <div className={styles.btnContainer}>

                        <FlatButtons
                        onClick={toggle}
                            className={styles.noBtn}
                        >
                            <Typography>
                                No, cancel
                            </Typography>
                        </FlatButtons>

                        <FlatButtons
                            className={styles.yesBtn}
                        >
                            <Typography>
                                Yes, delete
                            </Typography>
                        </FlatButtons>

                    </div>

                </div>

            </div>

        </div>
    )
}